import React from 'react';
import styles from './styles.scss';
import {IToothMovement, IToothMovementLimits, MovementType} from '@data/models';
import { cn } from '@utils';
import { getMovementValueColorClassName } from '@utils/movementLimitsUtils';

const formatValue = (value: number) => {
  const valueTwoDecimals = +value.toFixed(2);

  if (Math.abs(valueTwoDecimals) < 0.01) {
    return null;
  }

  return valueTwoDecimals.toFixed(2);
};

export type TableRowProps = {
  data?: IToothMovement;
  toothNumber: string;
  isLast: boolean;
  isFirst: boolean;
  movementLimits?: IToothMovementLimits;
};

const TableRow = ({ data, toothNumber, isLast, movementLimits }: TableRowProps) => {
  const getColorClassName = (value: number, movementType: MovementType) => {
    return getMovementValueColorClassName(value, movementLimits, movementType);
  };
  
  if (data) {
    return (
      <div className={cn(styles.teethMovement_table_row)}>
        <div
          className={cn(
            styles.teethMovement_table_cell,
            styles.__withoutBorder
          )}
        >
          {toothNumber}
        </div>

        <div
          className={cn(styles.teethMovement_table_cell, {
            [styles.__bottom]: isLast,
          }, getColorClassName(data.extrusionIntrusionTranslation, MovementType.ExtrusionIntrusionTranslation))}
        >
          <span>
              {formatValue(data.extrusionIntrusionTranslation) ?? <span className="!text-gray-400">0</span>}
          </span>
        </div>

        <div
          className={cn(styles.teethMovement_table_cell, {
            [styles.__bottom]: isLast,
          }, getColorClassName(data.buccalLingualTranslation, MovementType.BuccalLingualTranslation))}
        >
            <span>
              {formatValue(data.buccalLingualTranslation) ?? <span className="!text-gray-400">0</span>}
            </span>
        </div>

        <div
          className={cn(styles.teethMovement_table_cell, {
            [styles.__bottom]: isLast,
          }, getColorClassName(data.mesialDistalTranslation, MovementType.MesialDistalTranslation))}
        >
            <span>
              {formatValue(data.mesialDistalTranslation) ?? <span className="!text-gray-400">0</span>}
            </span>
        </div>

        <div
          className={cn(styles.teethMovement_table_cell, {
            [styles.__bottom]: isLast,
          }, getColorClassName(data.axialRotationDeg, MovementType.AxialRotation))}
        >
            <span>
              {formatValue(data.axialRotationDeg) ?? <span className="!text-gray-400">0</span>}
            </span>
        </div>

        <div
          className={cn(styles.teethMovement_table_cell, {
            [styles.__bottom]: isLast,
          }, getColorClassName(data.mesialDistalAngulationDeg, MovementType.MesialDistalAngulation))}
        >
            <span>
              {formatValue(data.mesialDistalAngulationDeg) ?? <span className="!text-gray-400">0</span>}
            </span>
        </div>

        <div
          className={cn(styles.teethMovement_table_cell, styles.__right, {
            [styles.__bottom]: isLast,
          }, getColorClassName(data.buccalLingualAngulationDeg, MovementType.BuccalLingualAngulation))}
        >
            <span>
              {formatValue(data.buccalLingualAngulationDeg) ?? <span className="!text-gray-400">0</span>}
            </span>
        </div>
      </div>
    );
  } else {
    return (
      <div className={cn(styles.teethMovement_table_row)}>
        <div
          className={cn(
            styles.teethMovement_table_cell,
            styles.__withoutBorder,
            'relative text-space opacity-40'
          )}
        >
          <div className="ml-0.5 h-[26px] w-0.5 bg-space opacity-40 absolute right-1/2 -top-0.5 rotate-45" />
          {toothNumber}
        </div>

        <div
          className={cn(styles.teethMovement_table_cell, {
            [styles.__bottom]: isLast,
          })}
        >
          {''}
        </div>

        <div
          className={cn(styles.teethMovement_table_cell, {
            [styles.__bottom]: isLast,
          })}
        >
          {''}
        </div>

        <div
          className={cn(styles.teethMovement_table_cell, {
            [styles.__bottom]: isLast,
          })}
        >
          {''}
        </div>

        <div
          className={cn(styles.teethMovement_table_cell, {
            [styles.__bottom]: isLast,
          })}
        >
          {''}
        </div>

        <div
          className={cn(styles.teethMovement_table_cell, {
            [styles.__bottom]: isLast,
          })}
        >
          {''}
        </div>

        <div
          className={cn(styles.teethMovement_table_cell, styles.__right, {
            [styles.__bottom]: isLast,
          })}
        ></div>
      </div>
    );
  }
};

export default TableRow;
